module.exports = __webpack_public_path__ + "static/img-hexapod-features-mobile-d71a4927c35f9fecae3ae89bc4da9d27.png";